import classNames from "classnames";
import {
	PageSectionProps,
	VideoSectionProps,
} from "../../../constants/pageSectionTypes";
import MarkdownRenderer from "../../common/MarkdownRenderer/MarkdownRenderer";
import VideoEmbed from "../../ui/VideoEmbed/VideoEmbed";
import "./VideoSection.scss";

const VideoSection = ({
	sectionContent,
	className,
}: PageSectionProps<VideoSectionProps>) => {
	return (
		<section
			className={classNames("video-section column keep-color", className)}>
			<MarkdownRenderer>{sectionContent.title}</MarkdownRenderer>
			<MarkdownRenderer>{sectionContent.content}</MarkdownRenderer>
			<VideoEmbed
				src={sectionContent.video.src}
				title={sectionContent.video.title}
				width={sectionContent.video.width}
				height={sectionContent.video.height}
				aspectRatio={sectionContent.video.aspectRatio}
			/>
		</section>
	);
};

export default VideoSection;
